export const GET_PRIMARY_QUESTIONNAIRE = "GET_PRIMARY_QUESTIONNAIRE";
export const GET_QUESTIONNAIRE_LISTING = "GET_QUESTIONNAIRE_LISTING";
export const GET_QUESTIONNAIRE_BY_ID = "GET_QUESTIONNAIRE_BY_ID";
export const SET_QUERY = "SET_QUERY";
export const SET_VIRTUAL_HEIGHT = "SET_VIRTUAL_HEIGHT";